<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <div class="center">
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'FAST_TASK_PROCESSING' | translate}}</span>
            </div>
        </div>
        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <div class="p-20">
                    <form #form="ngForm">
                        <div class="w-100-p" fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutAlign="start center">
                            <div class="fast-input">
                                <mat-form-field class="w-100-p" appearance="outline">
                                    <mat-label>{{'CAR'|translate}}</mat-label>
                                    <mat-select [(ngModel)]="selectCar" name="car"
                                        (selectionChange)="selectionCar($event.value)" placeholder="{{'CAR'|translate}}"
                                        required>
                                        <mat-option *ngFor="let item of cars" [value]="item">{{item.plate}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
    
                            <div class="fast-input">
                                <mat-form-field class="w-100-p" appearance="outline">
                                    <mat-label>{{'REGION'|translate}}</mat-label>
                                    <mat-select [(ngModel)]="selectPolygon" name="polygon"
                                        (selectionChange)="selectionPolygon($event.value)"
                                        placeholder="{{'REGION'|translate}}" required>
                                        <mat-option *ngFor="let item of polygons" [value]="item">{{item.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
    
                            <div class="fast-input">
                                <mat-form-field class="w-100-p" appearance="outline" floatLabel="always">
                                    <mat-label>{{'CONTAINER_COLLECTION_THRESHOLD'|translate}}</mat-label>
                                    <input matInput type="number" name="trashold" [(ngModel)]="poligonTrashold" required>
                                </mat-form-field>
                            </div>
    
                            <div>
                                <button mat-raised-button (click)="save()">{{'CREATE'|translate}}</button>
                            </div>
                        </div>
                    </form>
                </div>

                <div>
                    <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="id"
                    matSortDirection="asc" fusePerfectScrollbar>

                    <ng-container matColumnDef="plate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CAR'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let fastTask">
                            {{fastTask.car!=null?fastTask.car.plate:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'REGION'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let fastTask">
                            {{fastTask.polygon!=null?fastTask.polygon.name:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="treshold">
                        <mat-header-cell *matHeaderCellDef
                            mat-sort-header>{{'CONTAINER_COLLECTION_THRESHOLD'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let fastTask">
                            {{fastTask.polygon!=null?fastTask.polygon.treshold:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="allContainer">
                        <mat-header-cell *matHeaderCellDef
                            mat-sort-header>{{'CONTAINERS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let fastTask">
                            {{fastTask.allContainer!=null?fastTask.allContainer.length:'---'}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="fullContainer">
                        <mat-header-cell *matHeaderCellDef
                            mat-sort-header>{{'FULL_CONTAINERS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let fastTask">
                            {{fastTask.fullContainers!=null?fastTask.fullContainers.length:'---'}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="emptyContainer">
                        <mat-header-cell *matHeaderCellDef
                            mat-sort-header>{{'EMPTY_CONTAINERS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let fastTask">
                            {{fastTask.emptyContainers!=null?fastTask.emptyContainers.length:'---'}}
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let fastTask; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>